import axios from "axios";

export const allCoinLists = {
  moonrekt: ["BTC"], // Network does not have 'BNB', and We don't have SOL pricing yet, let just support BTC and ETH only
  tixwix: [
    "BTC",
    "ETH",
    "BNB",
    "LINK",
    "XRP",
    "XTZ",
    "UNI",
    "YFI",
    "LTC",
    "DOT",
    "COMP",
    "AAVE",
    "SUSHI",
    "SNX",
    "SOL",
    "DEFI",
    "FTT",
    "DOGE",
  ].sort(),
};

export const getBodPrices = async () => {
  // const endTime = moment.utc().unix();
  // const startTime = moment.utc().add(-1, "day").unix();

  // const tixwix = allCoinLists.tixwix.map((market) => {
  //   return axios
  //     .get(`/ftx/api/indexes/${market}/candles?resolution=86400&start_time=${startTime}&end_time=${endTime}`)
  //     .then(({ data }) => ({ market, type: 'tixwix', price: data?.result[0]?.open }));
  // });

  const moonrekt = allCoinLists.moonrekt.map((market) => {
    const url = `${process.env.REACT_APP_TICKING_PRICE_URL}/${market.toLowerCase()}/last/day`;
    return axios.get(url)
      .then(({ data }) => ({ market, type: "moonrekt", price: data?.open }));
  });

  return Promise.allSettled([...moonrekt]).then((data) =>
    data.reduce((acc, { status, value, reason }: any) => {
      if (status === "fulfilled") {
        acc.push(value);
      } else {
        console.error("getBodPrice rejected", reason);
      }
      return acc;
    }, [])
  );
};

